export default {
  noActiveCalls: 'No active calls',
};
